export const ExtLink = (props) => <a target="_blank" rel="noreferrer" {...props}></a>;
